export default "__VITE_ASSET__DvfxkS0M__"